import React from 'react'
import Privacy from 'src/app/Privacy/Privacy'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { privacyRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const PrivacyAppRoute: AppRoute = {
  id: AppLocation.Privacy,
  routeProps: privacyRouteProps,
  component: <Privacy />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default PrivacyAppRoute
